import { Button, ButtonsWrapper, Form, Loader } from '@thinknet-gmbh/platform-common-ui';
import { UploadFile } from 'antd/lib/upload/interface';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useCreateApplicant } from 'src/hooks/applicants/create-applicant.hook';

import { FormWrapper } from './applicant-request-form.styles';
import { GeneralFormItems } from './general-form-items';

const ApplicantRequestForm = ({ vacancyId }: { vacancyId: string }) => {
  const { t } = useTranslation(['common', 'vacancies']);
  const [form] = Form.useForm();
  const [docs, setDocs] = useState<{ resumeFiles: UploadFile[]; salutationFiles: UploadFile[] }>({
    resumeFiles: [],
    salutationFiles: [],
  });
  const { createApplicant, loading } = useCreateApplicant();

  const submitForm = (values: any) => {
    const { documents, ...rest } = values;

    createApplicant({
      variables: {
        payload: {
          documents: docs,
          vacancyId,
          ...rest,
        },
      },
    });
  };

  return (
    <FormWrapper>
      {loading && <Loader position="absolute" />}
      <Form
        validateMessages={{ required: t('common:validation.error.fieldRequired') }}
        layout="vertical"
        onFinish={submitForm}
        form={form}
      >
        <GeneralFormItems docs={docs} setDocuments={setDocs} />
        <ButtonsWrapper marginTop={6}>
          <Button
            onClick={() => {
              window.history.back();
              form.resetFields();
              setDocs({ resumeFiles: [], salutationFiles: [] });
            }}
          >
            {t('common:buttons.cancel')}
          </Button>
          <Button type="primary" htmlType="submit">
            {t('vacancies:buttons.submitApplication')}
          </Button>
        </ButtonsWrapper>
      </Form>
    </FormWrapper>
  );
};

export default ApplicantRequestForm;
